import { Heading1, Heading2 } from '@oppy/omniv2-ui';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <section className="fixed inset-0 bg-white">
      <div className="flex h-full flex-col items-center justify-center gap-4">
        <div>
          <Heading1>Page introuvable</Heading1>
          <Heading2>La page demandée n'existe pas</Heading2>
        </div>

        <Link to="/">Retourner à l'accueil</Link>
      </div>
    </section>
  );
}
